import { useMemo } from 'react';

import { Image } from '@change/ds-core-ui';

import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';

export const CampaignPhoto: React.FC = () => {
	const {
		data: { enrichedData },
	} = useDecisionMakerProfilePageData();

	const imgUrl = useMemo(() => enrichedData?.campaignPhotoUrl ?? null, [enrichedData]);

	if (!imgUrl) {
		return null;
	}
	return (
		<div className="w-full md:h-[300px] md:pr-6">
			<Image
				src={imgUrl}
				alt="decision maker campaign photo"
				className="h-full w-full object-cover"
				data-qa="campaign-photo"
			/>
		</div>
	);
};
